<ng-container *ngIf="!isUnchangeable() && !isInterviewing()">
  <!-- 人材側 -->
  <ng-container *ngIf="isWorkerSide()">
    <div class="float-right">
      <button
        class="btn btn-primary-dark border-0 margin-right-5"
        type="button" container="body" (click)="openChangeStatus('reset')"
      >
        <i class="fa fa-repeat margin-right-5"></i>初期化
      </button>
      <!-- 人材回答待ち。ユーザーが誤って辞退した場合を考慮してisWorkerNg()も入れている。 -->
      <button
          class="btn btn-primary-dark border-0 margin-right-5"
          type="button" container="body" (click)="openChangeStatus('cancel')"
        >
          <i class="fa fa-times margin-right-5"></i>取消
        </button>
      <ng-container
        ><!-- 人材問合せ待ち -->
        <button
          class="btn btn-primary-dark border-0 margin-right-5"
          type="button" container="body" (click)="openConfirmModal('worker')"
        >
          <i class="fa fa-envelope-o margin-right-5"></i>BP確認
        </button>
      </ng-container>
      <button
        class="btn btn-primary-dark border-0 margin-right-5"
        type="button" container="body" (click)="rejectOffer('worker')"
      >
        <i class="fa fa-hand-o-down margin-right-5"></i>辞退
      </button>
      <button
        class="btn btn-primary-dark border-0"
        type="button" container="body"
        data-toggle="modal"
        data-target="#offer_accept_modal"
        (click)="acceptOffer('worker')"
      >
        <i class="fa fa-hand-o-up margin-right-5"></i>承諾
      </button>
    </div>
  </ng-container>

  <!-- 案件側-->
  <ng-container *ngIf="isProjectSide()">
    <div class="float-right">
    <button
      class="btn btn-primary-dark border-0 margin-right-5"
      type="button" container="body" (click)="openChangeStatus('reset')"
    >
      <i class="fa fa-repeat margin-right-5"></i>初期化
    </button>
      <button
          class="btn btn-primary-dark border-0 margin-right-5"
          type="button" container="body" (click)="openChangeStatus('cancel')"
        >
          <i class="fa fa-times margin-right-5"></i>取消
        </button>
      <ng-container
        ><!-- 案件問合せ待ち -->
        <button
          class="btn btn-primary-dark border-0 margin-right-5"
          type="button" container="body" (click)="openConfirmModal('project')"
        >
          <i class="fa fa-envelope-o margin-right-5"></i>BP確認
        </button>
      </ng-container>
      <button
        class="btn btn-primary-dark border-0 margin-right-5"
        type="button" container="body" (click)="rejectOffer('project')"
      >
        <i class="fa fa-hand-o-down margin-right-5"></i>辞退
      </button>
      <button
        class="btn btn-primary-dark border-0"
        type="button" container="body"
        data-toggle="modal"
        data-target="#offer_accept_modal"
        (click)="acceptOffer('project')"
      >
        <i class="fa fa-hand-o-up margin-right-5"></i>承諾
      </button>
    </div>
  </ng-container>
</ng-container>

<!-- 面談中 -->
<ng-container *ngIf="isInterviewing()"
  ><!--面談中 -->
  <button
    class="btn btn-primary-dark float-right border-0"
    type="button"
    data-toggle="modal"
    data-target="#offer_accept_modal"
    (click)="openChangeStatus('succeeded')"
  >
    <i class="fa fa-handshake-o margin-right-5"></i> 成立
  </button>
  <button
    class="btn btn-primary-dark float-right border-0 margin-right-5"
    type="button"
    data-toggle="modal"
    data-target="#offer_cancel_modal"
    (click)="openChangeStatus('failed')"
  >
    <i class="fa fa-thumbs-o-up"
      ><i class="fa fa-thumbs-o-down btn-thumbs-down"></i></i
    >不成立
  </button>
</ng-container>

<button
  *ngIf="isInterviewing() || isUnchangeable()"
  class="btn btn-primary-dark border-0 margin-right-5 float-right"
  type="button" container="body" (click)="openChangeStatus('reset')"
>
  <i class="fa fa-repeat margin-right-5"></i>初期化
</button>
